import { render, staticRenderFns } from "./SlidingSwitch.vue?vue&type=template&id=0473c100&scoped=true&"
import script from "./SlidingSwitch.vue?vue&type=script&lang=js&"
export * from "./SlidingSwitch.vue?vue&type=script&lang=js&"
import style0 from "./SlidingSwitch.vue?vue&type=style&index=0&id=0473c100&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0473c100",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
installComponents(component, {VBtn,VBtnToggle})
